import React from "react";
import { KgNodePanelHeader } from "../../molecules/KgNodePanelHeader";
import { KgNodePanelTabs } from "../../molecules/KgNodePanelTabs";
import { PanelBody, PanelInner, PanelRoot } from "./KgNodePanel.styles";
import type { KgNodePanelProps } from "./KgNodePanel.types";
import { useKgNodePanel } from "./useKgNodePanel";
import { useKgNodePanelTabsScroll } from "./useKgNodePanelTabsScroll";

export const KgNodePanel: React.FC<KgNodePanelProps> = (props) => {
  const {
    isVisible,
    ariaLabel,
    header,
    tabs,
    activeTab,
    onTabChange,
    body,
    onClose,
  } = useKgNodePanel(props);

  const { scrollRef, setTabRef, canScrollLeft, canScrollRight, onScroll } =
    useKgNodePanelTabsScroll(activeTab);

  if (!isVisible) return null;

  return (
    <PanelRoot role="dialog" aria-label={ariaLabel}>
      <PanelInner>
        <KgNodePanelHeader
          headerIcon={header.headerIcon}
          logoUrl={header.logoUrl}
          title={header.title}
          subtitle={header.subtitle}
          externalUrl={header.externalUrl}
          onClose={onClose}
        />
        <KgNodePanelTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={onTabChange}
          scrollRef={scrollRef}
          setTabRef={setTabRef}
          onScroll={onScroll}
          canScrollLeft={canScrollLeft}
          canScrollRight={canScrollRight}
        />
        <PanelBody>{body}</PanelBody>
      </PanelInner>
    </PanelRoot>
  );
};

export default KgNodePanel;
